// « Nouvel éditeur mobile » — pieces of the « … » menu and of the sheets:
// full-width rows (≥ 48 px), a section title, the locked banner. Drawing only;
// every row calls one of the editor's existing handlers.
import { waSupportLink } from '@/lib/whatsappSupport';
import { M2 } from './theme';

export function M2Row({
  label,
  hint,
  icon,
  onClick,
  disabled,
  danger,
  active,
  href,
}: {
  label: string;
  hint?: string;
  icon?: React.ReactNode;
  onClick?: () => void;
  disabled?: boolean;
  danger?: boolean;
  active?: boolean;
  href?: string;
}) {
  const inner = (
    <>
      {icon && (
        <span
          aria-hidden
          className="w-9 h-9 shrink-0 rounded-xl flex items-center justify-center text-base"
          style={{ background: active ? `${M2.gold}26` : `${M2.gold}12`, color: danger ? M2.danger : M2.goldInk }}
        >
          {icon}
        </span>
      )}
      <span className="flex-1 min-w-0">
        <span className="block font-semibold leading-snug" style={{ fontSize: 15, color: danger ? M2.danger : M2.ink }}>{label}</span>
        {hint && <span className="block leading-snug mt-0.5" style={{ fontSize: 12.5, color: M2.muted }}>{hint}</span>}
      </span>
      {active && (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke={M2.goldDark} strokeWidth={3} strokeLinecap="round" strokeLinejoin="round" aria-hidden>
          <path d="M5 13l4 4L19 7" />
        </svg>
      )}
    </>
  );
  const cls = 'w-full min-h-12 flex items-center gap-3 px-4 py-2 text-left active:bg-black/5 disabled:opacity-40';
  if (href) {
    return (
      <a href={href} target="_blank" rel="noopener noreferrer" className={cls} style={{ textDecoration: 'none' }} aria-label={label}>
        {inner}
      </a>
    );
  }
  return (
    <button type="button" onClick={onClick} disabled={disabled} className={cls} aria-label={label} aria-pressed={active}>
      {inner}
    </button>
  );
}

export function M2SectionTitle({ children, team }: { children: React.ReactNode; team?: boolean }) {
  return (
    <div
      className="px-4 pt-4 pb-1.5 font-bold uppercase"
      style={{
        fontSize: 11.5,
        letterSpacing: '0.06em',
        color: team ? M2.goldInk : M2.muted,
        borderTop: team ? `1px solid ${M2.gold}33` : undefined,
        marginTop: team ? 8 : 0,
      }}
    >
      {children}
    </div>
  );
}

export const M2_HELP_MESSAGE = "Bonjour, j'ai besoin d'aide pour mon album Storiz.";
export const M2_LOCKED_MESSAGE = "Bonjour, j'ai une question sur mon album Storiz (en production).";

/** View-only album: what it is, and the one thing the customer can still do. */
export function M2LockedBar() {
  return (
    <div
      data-m2-locked=""
      role="status"
      className="shrink-0 px-3 pt-2.5 pb-3 flex flex-col gap-2"
      style={{ background: '#FEF3C7', borderTop: '1px solid #FDE68A' }}
    >
      <p className="text-center leading-snug" style={{ fontSize: 14, color: '#78350F' }}>
        🔒 Votre album est en cours de production. Vous pouvez le regarder ; il ne peut plus être modifié.
      </p>
      <a
        href={waSupportLink(M2_LOCKED_MESSAGE)}
        target="_blank"
        rel="noopener noreferrer"
        className="min-h-12 rounded-xl flex items-center justify-center gap-2 font-semibold"
        style={{ background: '#1F7A4A', color: '#fff', fontSize: 15, textDecoration: 'none' }}
        aria-label="Une question ? WhatsApp"
      >
        <span aria-hidden>💬</span> Une question ? WhatsApp
      </a>
    </div>
  );
}
